import React, { useState } from 'react';

function Day({ name, dayOfMonth, selected, onClick }) {
  return (
    <div className={`day-weekk ${selected ? 'selected-day' : ''}`} onClick={onClick}>
      <div className={`day-name-week ${selected ? 'current-day-name-week' : ''}`}>{name}</div>
      <div className={`day-date-week ${selected ? 'current-day-week' : ''}`}>{dayOfMonth}</div>
    </div>
  );
}

function Hour({ hour }) {
  return (
    <div className='hour-week-with-line'>
      <div className="hour-week">
        {hour}
      </div>
      <div className='hour-week-line'></div>
    </div>
  );
}

function Calendar() {
  const days = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  const hours = Array.from(Array(24).keys());

  const [selectedDay, setSelectedDay] = useState((new Date()).getDate());

  // Get current date
  const currentDate = new Date();

  // Calculate start date of the week (Sunday)
  const firstDayOfWeek = new Date(currentDate);
  firstDayOfWeek.setDate(currentDate.getDate() - currentDate.getDay());

  // Array to store dates for each day of the week
  const datesForWeek = [];

  // Loop through each day of the week
  for (let i = 0; i < 7; i++) {
    const date = new Date(firstDayOfWeek);
    date.setDate(firstDayOfWeek.getDate() + i);
    datesForWeek.push(date.getDate());
  }

  const handleDayClick = (day) => {
    setSelectedDay(day);
  };

  return (
    <div className="calendar-week">
      <div className="days-week">
        {days.map((day, index) => (
          <Day key={index} name={day} dayOfMonth={datesForWeek[index]} selected={selectedDay === datesForWeek[index]} onClick={() => handleDayClick(datesForWeek[index])} />
        ))}
      </div>
      <div className="hours-week">
        {hours.map((hour, index) => (
          <Hour key={index} hour={(hour % 12 === 0 ? 12 : hour % 12) + (hour < 12 ? ' AM' : ' PM')} />
        ))}
      </div>
    </div>
  );
}

const CalendarWeek = () => {
  return (
    <div>
      <Calendar />
    </div>
  );
}

export default CalendarWeek;